import styled from "styled-components"
import { zeroLineHeight, wrapWhenNarrow } from '../styles/mixins'
import Icon from "../Icon"

const Container = styled.div<{ $width: string }>`
  width: ${props => props.$width};
  border-radius: 8px;
  border: 1px solid ${props => props.theme.colors.gray_300};
  padding: 12px;
  display: flex;
  position: relative;
`

const Label = styled.p`
  font-weight: 500;
  font-size: 12px;
  color: ${props => props.theme.colors.gray_500};
  ${zeroLineHeight}
  margin: 0px;
  margin-top: 4px;
  margin-left: 12px;
`

const Value = styled.p`
  font-weight: 700;
  font-size: 12px;
  color: ${props => props.theme.colors.gray_900};
  ${zeroLineHeight}
  margin: 0px;
  margin-top: 16px;
  margin-left: 12px;
  ${wrapWhenNarrow}
`

export default function ListItem({ width, icon, label, value }: { theme: string, width: string, icon: string, label: string, value: string }) {
  return (
    <Container $width={width}>
      <Icon path={icon} width="24px" height="24px" />
      <div>
        <Label>{label}</Label>
        <Value>{value}</Value>
      </div>
    </Container>
  )
}